import React, {useCallback, useEffect, useState} from 'react';
import {Box, Fade, Modal, Typography} from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import {did,  menu,  sip} from "../translate";
import {useDispatch, useSelector} from "react-redux";
import Api from "../Api";
import {Link} from "react-router-dom";
import moment from "moment";

import {style,} from "../helpers/style";


function SingleSipProvider({open, edit, setOpen}) {
    const [form, setForm] = useState({
        operator: '',
        note: '',
        phone: '',
        profile: '',
        serverHost: '',
        username: '',
        password: '',
        line: '1'
    })
    const profile = useSelector(state => state.users.ursData)
    const [loading,setLoading] = useState(true)
    useEffect(() => {
        if (edit) {
            (async () => {
               try {
                   const {data} = await Api.getSingleProvider(edit)
                   setForm(data.data)
                   setLoading(false)
               }catch (e) {

               }
            })()
        }
    }, [edit])
    if (loading) return null
    return (
        <>

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={() => setOpen(false)}
                closeAfterTransition
                slots={{backdrop: Backdrop}}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <div className="d-flex flex-row justify-content-between">
                            <Typography id="transition-modal-title" variant="h6" component="h2">
                                {menu.provide[+localStorage.getItem('atsLang')  || 1]}
                            </Typography>
                            <span style={{cursor: 'pointer'}} onClick={() => setOpen(false)}>
                            x
                        </span>
                        </div>

                        <div id="transition-modal-description sip_content"  style={{marginTop: 20}}>
                            <div className="d-flex justify-content-center" style={{margin:'5px 0'}}><b style={{marginRight:5}}>{sip.phone[+localStorage.getItem('atsLang')  || 1]} </b> - {form.username}</div>
                            <div className="d-flex justify-content-center" style={{margin:'5px 0'}}><b style={{marginRight:5}}>{sip.forward[+localStorage.getItem('atsLang')  || 1]} </b> - {form.redirect?.output}</div>
                            <div className="d-flex justify-content-center" style={{margin:'5px 0'}}><b style={{marginRight:5}}>{did.line[+localStorage.getItem('atsLang')  || 1]} </b> - {form.lines}</div>
                            <div className="d-flex justify-content-center" style={{margin:'5px 0'}}><b style={{marginRight:5}}>{did.used_lines[+localStorage.getItem('atsLang')  || 1]} </b> - {form.totalCount}</div>
                            <div className="d-flex justify-content-center" style={{margin:'5px 0'}}><b style={{marginRight:5}}>{did.calc[+localStorage.getItem('atsLang')  || 1]} </b> - <Link to={`/history?number=` + form.pref + form.did + '&startTime=' + moment().format('DD-MM-YYYY')}>{form.history}</Link></div>
                            <div className="d-flex justify-content-center" style={{margin:'5px 0'}}><b style={{marginRight:5}}>{sip.note[+localStorage.getItem('atsLang')  || 1]} </b> - {form.notes}</div>
                            <div className="d-flex justify-content-center" style={{margin:'5px 0'}}><b style={{marginRight:5}}>{did.active[+localStorage.getItem('atsLang')  || 1]} </b> : {form.in} - {form.out}</div>
                            <div className="d-flex justify-content-center" style={{margin:'5px 0'}}><b style={{marginRight:5}}>{did.date[+localStorage.getItem('atsLang')  || 1]} </b> : {form.inTime?.intime} - {form.outTime?.outtime}</div>
                            <div className="d-flex justify-content-center" style={{margin:'5px 0'}}><b style={{marginRight:5}}>{did.no_line[+localStorage.getItem('atsLang')  || 1]} </b> : {form.nodline}</div>
                            {Object.keys(profile).length !== 0?<div className="d-flex justify-content-center" style={{margin:'5px 0'}}><b style={{marginRight:5}}> Password </b> : {form.password}</div>:null}
                        </div>
                        <div className="d-flex justify-content-center" style={{marginTop: 20}}>
                            <button onClick={() => setOpen('')} className="addBtn">
                                OK
                            </button>
                        </div>
                    </Box>
                </Fade>
            </Modal>
        </>

    );
}

export default SingleSipProvider;
